export const SLIDES_TITLE_MSG =
  'Now you have more data to make medical decisions';
export const SLIDE_ONE_DESCRIPTION = 'MenHealth Platform';
export const SLIDE_TWO_DESCRIPTION = 'Reports';
export const SLIDE_ONE_MSG =
  "MenHealth platform enables doctors to monitor their patients' urine flow diaries, generated remotely by the patients through MenHealth application. The HIPAA compliant voiding diary enables physicians to track the impact of any prescription medication or medical treatment that affect voiding and water metabolism. Doctors can secu" +
  'rely message patients through the platform.';
export const SLIDE_TWO_MSG =
  "Patient reports are generated based on patients' test results (maximum flow, average flow, hesitancy, and voided volume, time of day) over any period of time a physician wants to see. Reports can be saved in PDF format, printed, or integrated with EHR/EMR systems.";
export const PAGE_TITLE_MSG =
  'Now you have more data to make medical decisions';
export const HEADER_SUBTITLE = 'MenHealth Platform';
export const PATIENTS_LIST_ALT = 'Patients list';
export const PATIENT_RESULTS_ALT = 'Patients result';
export const DIARY_REPORTS_ALT = 'Diary reports';
export const TABLET_REPORTS_ALT = 'Reports on tablet';
export const FOOTER_SUBTITLE = 'Reports';
export const HEADER_CONTENT =
  "MenHealth platform enables doctors to monitor their patients' urine flow diaries, generated remotely by the patients through MenHealth application.\n\n" +
  'The HIPAA compliant voiding diary enables physicians to track the impact of any prescription medication or medical treatment that affect voiding and water metabolism.\n\n' +
  'Doctors can securely message patients through the platform.';
export const FOOTER_CONTENT =
  "Patient reports are generated based on patients' test results (maximum flow, average flow, hesitancy, and voided volume, time of day) over any period of time a physician wants to see.\n\n" +
  'Reports can be saved in PDF format, printed, or integrated with EHR/EMR systems.';
export const SCHEDULE_A_DEMO_MSG = 'Schedule Demo';
export const CONTACT_US_MSG = 'Contact Us';
export const MOST_POPULAR_LABEL = 'MOST POPULAR';
export const DOWNGRADE_UNAVAILABLE = `DOWNGRADE UNAVAILABLE`;
export const PLAN_BLOCKED = 'NOT AVAILABLE';
export const CURRENT_PLAN = 'CURRENT PLAN';
export const CANCELED_PLAN = 'CANCELED PLAN';
export const PENDING_PLAN = 'WAITS FOR ACTIVATION';
export const PATIENT_SELF_MONITORING_LABEL = 'PATIENT SELF MONITORING PLAN';
export const PLAN_COMMITMENT = 'Month to month. Cancel anytime.';
export const PROVIDER_NO_ONE_PLAN_AVAILABLE =
  'No one provider plan is available. Please contact us.';
